import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { IoMdArrowRoundUp } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
import { Link } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("Home");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: "90%",
    bgcolor: "background.paper",
    boxShadow: 24,
  };
  useEffect(() => {
    const select = (el, all = false) => {
      el = el.trim();
      if (all) {
        return [...document.querySelectorAll(el)];
      } else {
        return document.querySelector(el);
      }
    };
    const on = (type, el, listener, all = false) => {
      if (all) {
        select(el, all).forEach((e) => e.addEventListener(type, listener));
      } else {
        select(el, all).addEventListener(type, listener);
      }
    };
    const onscroll = (el, listener) => {
      el.addEventListener("scroll", listener);
    };
    let navbarlinks = select("#navbar .scrollto", true);
    const navbarlinksActive = () => {
      let position = window.scrollY + 200;
      navbarlinks.forEach((navbarlink) => {
        if (!navbarlink.hash) return;
        let section = select(navbarlink.hash);
        if (!section) return;
        if (
          position >= section.offsetTop &&
          position <= section.offsetTop + section.offsetHeight
        ) {
          navbarlink.classList.add("active");
        } else {
          navbarlink.classList.remove("active");
        }
      });
    };
    window.addEventListener("load", navbarlinksActive);
    onscroll(document, navbarlinksActive);
    const scrollto = (el) => {
      let header = select("#header");
      let offset = header.offsetHeight;

      if (!header.classList.contains("header-scrolled")) {
        offset -= 10;
      }

      let elementPos = select(el).offsetTop;
      window.scrollTo({
        top: elementPos - offset,
        behavior: "smooth",
      });
    };

    /**
     * Toggle .header-scrolled class to #header when page is scrolled
     */
    let selectHeader = select("#header");
    if (selectHeader) {
      const headerScrolled = () => {
        if (window.scrollY > 100) {
          selectHeader.classList.add("header-scrolled");
        } else {
          selectHeader.classList.remove("header-scrolled");
        }
      };
      window.addEventListener("load", headerScrolled);
      onscroll(document, headerScrolled);
    }

    /**
     * Back to top button
     */
    let backtotop = select(".back-to-top");
    if (backtotop) {
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add("active");
        } else {
          backtotop.classList.remove("active");
        }
      };
      window.addEventListener("load", toggleBacktotop);
      onscroll(document, toggleBacktotop);
    }
  }, []);

  let arr = [
    { name: "Home", id: "#hero" },
    { name: "Usecases", id: "#usecase" },
    { name: "About Pratham", id: "#about" },
    { name: "Capabilities", id: "#services" },
    { name: "Expert Opinion", id: "#testimonials" },
    { name: "Contact Us", id: "#contact" },
  ];
  return (
    <>
      <header id="header" className="header fixed-top" data-aos="fade-up">
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <Link to="/" className="logo d-flex align-items-center">
            <img
              src="../assets/newLogo2.png"
              alt="Logo"
              className="dark:invert"
              priority
            />
          </Link>

          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <a className="nav-link scrollto active" href="#hero">
                  Home
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#usecase">
                  Usecases
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#about">
                  About Pratham
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href="#services">
                  Capabilities
                </a>
              </li>

              <li>
                <a className="nav-link scrollto" href="#testimonials">
                  Expert Opinion
                </a>
              </li>

              <li>
                <a className="nav-link scrollto" href="#contact">
                  Contact Us
                </a>
              </li>
              <li>
                <Link to="/signin" className="getstarted scrollto">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/device-onboard" className="getstarted scrollto">
                  Device Onboard
                </Link>
              </li>
            </ul>
            <RxHamburgerMenu
              className="bi bi-list mobile-nav-toggle"
              onClick={handleOpen}
            />
          </nav>
        </div>
      </header>
      <a
        href="#top"
        className="back-to-top d-flex align-items-center justify-content-center"
        style={{ color: "#fff" }}
      >
        <IoMdArrowRoundUp className="bi bi-arrow-up-short" />
      </a>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <nav id="navbar" className="navbar">
            <ul style={{ display: "block", padding: "10px 0" }}>
              {arr.map((item, i) => (
                <li
                  onClick={() => {
                    handleClose();
                    setActive(item.name);
                  }}
                  key={i}
                >
                  <a
                    className={
                      item.name === active
                        ? "nav-link scrollto active"
                        : "nav-link scrollto"
                    }
                    href={item.id}
                  >
                    {item.name}
                  </a>
                </li>
              ))}

              <li onClick={handleClose} className=" mt-2">
                <Link to="/signin" className="getstarted scrollto">
                  Login
                </Link>
              </li>
            </ul>
          </nav>
        </Box>
      </Modal>
    </>
  );
}

export default Navbar;
